<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
    :class="{
      rtl: $i18n.locale === 'fa' || $i18n.locale === 'ar',
      ltr: $i18n.locale === 'en',
    }"
  >
    <template>
      <custom-popup v-model="dialog" :cons="cons">
        <template v-slot:helpinfo>
          <help-info
            v-if="false"
            :element-name="`${serviceName}-${componentName}-add-edit-code-a`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('discount_obj.create_edit_code')"
          />
        </template>
        <div class="pa-4">
          <custom-tabs v-model="tabs" :tab-items="tabIs" grow>
            <template v-slot:helpinfo="{ tab }">
              <help-info
                v-if="tab && tab.value && tab.text"
                :element-name="`${serviceName}-${componentName}-tab-${tab.value}`"
                :service-name="serviceName"
                :help-data="helpData"
                class="buttoninfo"
                :label="tab.text"
              />
            </template>
            <template v-slot:staticItems>
              <v-tab-item>
                <v-row class="mt-4" no-gutters>
                  <v-col
                    class="pa-2"
                    cols="12"
                    lg="4"
                    md="6"
                    order="1"
                    order-md="2"
                  >
                    <v-radio-group
                      v-model="info.coding_type"
                      :menu-props="{ offsetY: true }"
                      class="ma-0 pa-0"
                      dense
                      mandatory
                      row
                    >
                      <template v-slot:label>
                        <div
                          :class="{
                            'text-right':
                              $i18n.locale === 'fa' || $i18n.locale === 'ar',
                            'text-left': $i18n.locale === 'en',
                          }"
                        >
                          {{ $t("discount_obj.coding_type_label") }}
                        </div>
                      </template>
                      <v-radio
                        v-for="(dc, i) in translatedCodingTypeItems"
                        :key="i"
                        :label="dc.text"
                        :value="dc.value"
                      />
                    </v-radio-group>
                  </v-col>

                  <v-col
                    class="pa-2"
                    cols="12"
                    lg="4"
                    md="6"
                    order="2"
                    order-md="3"
                  >
                    <v-radio-group
                      v-model="info.status"
                      :menu-props="{ offsetY: true }"
                      class="ma-0 pa-0"
                      dense
                      mandatory
                      row
                    >
                      <template v-slot:label>
                        <div
                          :class="{
                            'text-right':
                              $i18n.locale === 'fa' || $i18n.locale === 'ar',
                            'text-left': $i18n.locale === 'en',
                          }"
                        >
                          {{ $t("discount_obj.status_label") }}
                        </div>
                      </template>
                      <v-radio
                        :label="$t('discount_obj.status_active')"
                        value="active"
                      />
                      <v-radio
                        :label="$t('discount_obj.status_deactivate')"
                        value="deactivate"
                      />
                    </v-radio-group>
                  </v-col>
<!-- فیلد تعداد کدهای گروهی -->
<v-col
  v-if="info.coding_type === 'group'"
  class="pa-2"
  cols="12"
  lg="4"
  md="6"
  order="4"
>
  <div class="rowinfo">
    <v-text-field
      v-model.number="info.quantity"
      class="rounded-lg contentinfo"
      clearable
      dense
      :label="$t('discount_obj.quantity')"
      outlined
      type="number"
      min="1"
    />
    <help-info
      :element-name="`${serviceName}-${componentName}-info-quantity`"
      :service-name="serviceName"
      :help-data="helpData"
      class="buttoninfo"
      :label="$t('discount_obj.quantity')"
    />
  </div>
</v-col>

                  <v-col
                    class="pa-2"
                    cols="12"
                    lg="4"
                    md="6"
                    order="3"
                    order-md="1"
                  >
                    <div class="rowinfo">
                      <v-text-field
                        v-model="randomCode"
                        class="rounded-lg contentinfo"
                        clearable
                        dense
                        :label="$t('discount_obj.discount_code')"
                        outlined
                      >
                        <template v-slot:append>
                          <v-btn
                            class="rounded-lg mt-n1 me-n1"
                            color="success"
                            fab
                            x-small
                            @click="createRandomCode()"
                          >
                            <v-icon>mdi-reload</v-icon>
                          </v-btn>
                        </template>
                      </v-text-field>
                      <help-info
                        :element-name="`${serviceName}-${componentName}-randomCode`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('discount_obj.discount_code')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12" lg="4" md="6" order="4">
                    <div class="rowinfo">
                      <v-select
                        v-model="info.type"
                        :items="translatedDiscountTypeItems"
                        :menu-props="{ offsetY: true }"
                        class="rounded-lg contentinfo"
                        clearable
                        dense
                        :label="$t('discount_obj.discount_type')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-discountType`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('discount_obj.discount_type')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12" lg="4" md="6" order="4">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="info.value"
                        append-icon="mdi-percent"
                        class="rounded-lg contentinfo"
                        clearable
                        dense
                        :label="$t('discount_obj.discount_value')"
                        outlined
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-info-value`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('discount_obj.discount_value')"
                      />
                    </div>
                  </v-col>

                  <v-col class="pa-2" cols="12" lg="4" md="6" order="4">
                    <div class="rowinfo">
                      <v-text-field
                        v-model="info.discount_limit"
                        class="rounded-lg contentinfo"
                        clearable
                        dense
                        hide-spin-buttons
                        :label="$t('discount_obj.discount_limit')"
                        outlined
                        :placeholder="$t('discount_obj.no_limit')"
                        type="number"
                      />
                      <help-info
                        :element-name="`${serviceName}-${componentName}-info-discount_limit`"
                        :service-name="serviceName"
                        :help-data="helpData"
                        class="buttoninfo"
                        :label="$t('discount_obj.discount_limit')"
                      />
                    </div>
                  </v-col>
                </v-row>
              </v-tab-item>

              <v-tab-item class="pt-4">
                <discount-settings-editor v-model="info.settings" />
              </v-tab-item>
            </template>
          </custom-tabs>
        </div>
      </custom-popup>
    </template>
  </help-info-wrapper>
</template>

<script>
import { mapState } from "vuex";
import DiscountSettingsEditor from "@/view/pages/qrland/components/qrManage/manageShop/discountSettingsEditor.vue";

export default {
  name: "discountEditor",
  components: { DiscountSettingsEditor },
  props: {
    show: Boolean,
    edit: Object || null,
  },
  data() {
    return {
      helpData: [],
      componentName: "discountEditor",
      serviceName: "Qrland",
      loading: false,
      codingTypeItems: [
        { value: "single", text: "" },
        { value: "group", text: "" },
      ],
      discountTypeItems: [
        { value: "percent", text: "", icon: "mdi-percent" },
        { value: "fixed", text: "", icon: "mdi-currency-rial" },
      ],
      info: {
        coding_type: "single",
        start_time: "",
        end_time: "",
        status: "active",
        type: "percent",
        value: "",
        sms_text: "",
        discount_limit: null,
        quantity:1,
        settings: {
          FunctionType: { name: "AllShoppingCart" },
          BasketCondition: { name: "NoConditions" },
          UserSettings: { name: "AllUser" },
          LimitationUse: { name: "NoLimitations" },
          start_time: "",
          end_time: "",
        },
        advanced_setting_id: null,
      },
      tabs: 0,
      randomCode: "",
    };
  },
  computed: {
    ...mapState("localstorage", ["createQrID"]),
    dialog: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
    prop: {
      get() {
        return this.edit;
      },
      set(value) {
        this.$emit("update:edit", value);
      },
    },
    tabIs() {
      return [
        {
          text: this.$t("discount_obj.tab_create_discount"),
          value: "create_discount_code",
          icon: "",
        },
        {
          text: this.$t("discount_obj.tab_settings"),
          value: "settings",
          icon: "",
        },
      ];
    },
    cons() {
      return {
        title: this.$t("discount_obj.create_edit_code"),
        buttons: [{ type: "submit", handler: () => this.submit() }],
      };
    },
    translatedCodingTypeItems() {
      return this.codingTypeItems.map((item) => ({
        ...item,
        text:
          item.value === "single"
            ? this.$t("discount_obj.coding_type_single")
            : this.$t("discount_obj.coding_type_group"),
      }));
    },
    translatedDiscountTypeItems() {
      return this.discountTypeItems.map((item) => ({
        ...item,
        text:
          item.value === "percent"
            ? this.$t("discount_obj.discount_type_percent")
            : this.$t("discount_obj.discount_type_fixed"),
      }));
    },
  },
  mounted() {
    this.createRandomCode();
  },
  methods: {
    submit() {
      this.loading = true;
      this.info.code = this.randomCode;
      this.$api
        .post("/v1/testQr/discount-code", {
          ...this.info,
          qr_id: this.createQrID,
        })
        .then(({ data }) => {
          this.reInfoProps();
          this.$emit("fetch");
          this.edit
            ? this.$toast.success(this.$t("discount_obj.success_edit"))
            : this.$toast.success(this.$t("discount_obj.success_create"));
        })
        .catch(({ response }) => {
          this.dialog = true;
          if (response.data.errors.code) {
            this.$toast.error(response.data.errors.code[0]);
          } else if (response.data.errors.value) {
            this.$toast.error(this.$t("discount_obj.error_value_empty"));
          } else if (!this.info.settings.start_time) {
            this.$toast.error(this.$t("discount_obj.error_start_time"));
          } else if (!this.info.settings.end_time) {
            this.$toast.error(this.$t("discount_obj.error_end_time"));
          } else if (
            this.info.settings.end_time === this.info.settings.start_time
          ) {
            this.$toast.error(this.$t("discount_obj.error_same_time"));
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    createRandomCode() {
      const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
      const allChars =
        "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let result = "";
      for (let i = 0; i < 6; i++) {
        result += chars.charAt(Math.floor(Math.random() * chars.length));
      }
      for (let i = result.length; i < 8; i++) {
        result += allChars.charAt(Math.floor(Math.random() * allChars.length));
      }
      this.randomCode = result;
    },
 syncEditProduct() {
      if (this.edit) {
        this.info.discount_limit = this.edit.discount_code[0].discount_limit;
        this.info.code = this.edit.discount_code[0].code;
        this.randomCode = this.edit.discount_code[0].code;
        this.info.coding_type = this.edit.discount_code[0].coding_type;
        this.info.sms_text = this.edit.discount_code[0].sms_text;
        this.info.value = this.edit.discount_code[0].value;
        this.info.status = this.edit.discount_code[0].status;
        this.info.settings = JSON.parse(this.edit.settings);
        this.info.id = this.edit.discount_code[0].id;
        this.info.advanced_setting_id = this.edit.discount_code[0].advanced_setting_id;        
        this.info.quantity = this.edit.discount_code[0].quantity || 1; 
      } else {
        this.reInfoProps();
      }
    },
 reInfoProps() {
      this.info = {
        coding_type: "single",
        start_time: "",
        end_time: "",
        status: "active",
        type: "percent",
        value: "",
        sms_text: "",
        discount_limit: null,
        quantity: 1,
        code: "",
        settings: {
          FunctionType: { name: "AllShoppingCart" },
          BasketCondition: { name: "NoConditions" },
          UserSettings: { name: "AllUser" },
          LimitationUse: { name: "NoLimitations" },
          start_time: "",
          end_time: "",
        },
      };
      this.createRandomCode();
    },
  },
    watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
    prop() {
      this.syncEditProduct();
    },
  },
};
</script>

<style scoped>
.rtl {
  direction: rtl;
}
.ltr {
  direction: ltr;
}
</style>
